import { axiosApiInstance, headers } from './_httpHeaders';

// U4103. 고객 메뉴 리스트
// 모의해킹 취약점 조치
// 2차인증 완료 후 대시보드 좌측 메뉴리스트 조회 시 2차인증여부 재검증
export const getMenuList = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/dashBoard/selectMenuList.do`,
    params: {
      smsKey: userInfo.smsKey,
      noCert: userInfo.noCert,
    },
  });
